module.exports = __webpack_public_path__ + "img/loading.7526d6eb.gif";